/**
 * Lê um Blob como texto.
 *
 * Usa FileReader em vez de `blob.text()`: o método existe nos navegadores,
 * mas só foi declarado nas libs de tipo do TypeScript 4.x — este projeto
 * está no 3.7, onde `blob.text()` não compila.
 *
 * Serve para extrair a mensagem de erro do backend quando a resposta veio
 * com `responseType: 'blob'` (download de XML/ZIP) e o corpo, em vez do
 * arquivo, traz o JSON de erro.
 */
export default function readBlobAsText(blob: Blob): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (): void => resolve(String(reader.result ?? ''));
    reader.onerror = (): void => reject(reader.error);
    reader.readAsText(blob);
  });
}
